// Mock data for Prosafe Fire Protection website

export const companyInfo = {
  name: "Prosafe Fire Protection N.V.",
  logo: "PROSAFE",
  tagline: "Veiligheid boven alles – Uw partner in brandbescherming."
};

export const navigation = [
  { id: "home", label: "Home", href: "/" },
  { 
    id: "diensten", 
    label: "Diensten", 
    href: "/#diensten",
    subItems: [
      { id: "brandblussystemen", label: "Brandblussystemen", href: "/diensten/brandblussystemen" },
      { id: "branddetectie", label: "Branddetectie & Alarmsystemen", href: "/#branddetectie" },
      { id: "onderhoud", label: "Onderhoud & Inspectie", href: "/#onderhoud" },
      { id: "advies", label: "Advies & Brandpreventie", href: "/#advies" },
      { id: "noodverlichting", label: "Noodverlichting & Evacuatie", href: "/#noodverlichting" }
    ]
  },
  { id: "projecten", label: "Projecten", href: "/#projecten" },
  { id: "contact", label: "Contact", href: "/contact" }
];

export const heroContent = {
  headline: ["Professionele", "brandveiligheid,", "vandaag en morgen."],
  description: "Proactief bewustzijn en verantwoordelijk handelen zijn de meest effectieve verdediging tegen brandgevaar.",
  ctaText: "OFFERTE",
  backgroundImages: [
    "https://customer-assets.emergentagent.com/job_firepro-website/artifacts/0m6s0qm7_header.webp",
    "/hero1.webp",
    "/hero2.webp"
  ]
};

export const visualHighlights = [
  {
    id: 1,
    image: "/slider_home1.webp",
    alt: "Buckeye brandblussers"
  },
  {
    id: 2,
    image: "/slider_home2.webp",
    alt: "Buckeye water brandblussers"
  },
  {
    id: 3,
    image: "/slider_home3.webp",
    alt: "Buckeye mobiele blussystemen"
  }
];

export const companyIntro = {
  title: "PROSAFE FIRE PROTECTION N.V.",
  paragraphs: [
    "Prosafe Fire Protection N.V. is een toonaangevend bedrijf gespecialiseerd in professionele brandbeveiligingsoplossingen. Wij ondersteunen organisaties bij het beschermen van mensen, gebouwen en bedrijfscontinuïteit door middel van betrouwbare en gecertificeerde brandveiligheidssystemen.",
    "Met een deskundig team en jarenlange ervaring bieden wij oplossingen die voldoen aan internationale normen en lokale regelgeving. Onze aanpak is praktisch, klantgericht en gericht op langdurige veiligheid."
  ]
};

export const whyProsafe = {
  title: "WAAROM PROSAFE FIRE PROTECTION?",
  image: "https://customer-assets.emergentagent.com/job_firepro-website/artifacts/9zrowvg6_691a34f970793ea00ccf8dbc_fire%20safety.png",
  reasons: [
    { number: 1, text: "Ervaren en gecertificeerde specialisten" },
    { number: 2, text: "Oplossingen op maat" },
    { number: 3, text: "Snelle service en ondersteuning" },
    { number: 4, text: "Focus op preventie en continuïteit" }
  ]
};

export const missionVision = {
  mission: {
    title: "ONZE MISSIE",
    text: "Het leveren van hoogwaardige brandbeveiligingsoplossingen die risico's minimaliseren en bijdragen aan een veilige werkomgeving voor iedereen."
  },
  vision: {
    title: "ONZE VISIE",
    text: "Een samenleving waarin brandveiligheid vanzelfsprekend is en organisaties vertrouwen hebben in hun beschermingssystemen."
  }
};

export const ctaSection = {
  headline: ["NEEM", "VANDAAG", "NOG", "CONTACT MET ONS OP"],
  description: "Wilt u weten welke oplossing het beste past bij uw organisatie? Vraag een vrijblijvende offerte aan of plan een inspectie.",
  ctaText: "CONTACT",
  backgroundImage: "https://images.pexels.com/photos/15437910/pexels-photo-15437910.jpeg"
};

export const footer = {
  logo: "https://customer-assets.emergentagent.com/job_firepro-website/artifacts/zd6pwbo8_logo.png",
  subscriptionText: "Blijf geïnformeerd en een stap voor. Abonneer u op onze nieuwsbrief voor beknopte updates, praktische inzichten en relevant nieuws—rechtstreeks in uw inbox.",
  subscriptionPlaceholder: "SUBSCRIBE | Your email",
  copyright: `Copyright © ${new Date().getFullYear()} PROSAFE`
};

export const services = [
  {
    id: "brandblussystemen",
    title: "Brandblussystemen",
    description: "Wij leveren en installeren draagbare brandblussers en vaste blussystemen die geschikt zijn voor diverse risico's en toepassingen."
  },
  {
    id: "branddetectie",
    title: "Branddetectie & Alarmsystemen",
    description: "Wij installeren betrouwbare branddetectie- en alarmsystemen die vroegtijdige waarschuwing mogelijk maken en levens redden."
  },
  {
    id: "onderhoud",
    title: "Onderhoud & Inspectie",
    description: "Regelmatig onderhoud en inspectie zijn essentieel voor een optimale werking. Prosafe verzorgt periodieke controles, rapportages en certificering."
  },
  {
    id: "advies",
    title: "Advies & Brandpreventie",
    description: "Wij voeren risicoanalyses uit en adviseren organisaties over brandpreventiemaatregelen, noodplannen en wet- en regelgeving."
  },
  {
    id: "noodverlichting",
    title: "Noodverlichting & Evacuatie",
    description: "Installatie en onderhoud van noodverlichting en evacuatiesystemen voor veilige vluchtroutes bij noodsituaties."
  }
];
